import * as React from "react";
import {Navigate} from "react-router-dom";


import AppLayout from "Layout";
import {PRICING_ROUTES} from "@constants"
import PricingChangesPage from "./Changes";
import PricingMarketAnalyzerPage from "./MarketAnalyzer";
import PriceDiscountPage from "./PriceDiscount";
import PricingPriceEvolutionPage from "./PriceEvolution";
import PricingSideComparisonPage from "./SideComparison";
export const PricingRoutes = {
    path: PRICING_ROUTES.PATH,
    title: PRICING_ROUTES.TITLE,
    accessKey: PRICING_ROUTES.ACCESS_KEY,
    icon: 'tags',
    element: <AppLayout />,
    description: "Analyzes  pricing and discounting for a specific scope of own client's products and competition",
    children: [{
        element: <Navigate to={PRICING_ROUTES.CHANGES_PATH} replace />,  index: true
    }, {
        title: PRICING_ROUTES.OVERVIEW_TITLE,
        path: PRICING_ROUTES.OVERVIEW_PATH,
        dashboardKey: PRICING_ROUTES.OVERVIEW_ID,
        element: <PriceDiscountPage />
    }, {
        path: 'divider'
    }, {
        title: 'Pricing Changes',
        path: PRICING_ROUTES.CHANGES_PATH,
        dashboardKey: PRICING_ROUTES.CHANGES_ID,
        element: <PricingChangesPage />
    }, {
        title: 'Market Analyzer',
        path: PRICING_ROUTES.MARKET_ANALYZER_PATH,
        dashboardKey: PRICING_ROUTES.MARKET_ANALYZER_ID,
        element: <PricingMarketAnalyzerPage />
    }, {
        title: 'Price Evolution',
        path: PRICING_ROUTES.PRICE_EVOLUTION_PATH,
        dashboardKey: PRICING_ROUTES.PRICE_EVOLUTION_ID,
        element: <PricingPriceEvolutionPage />
    }, {
        title: 'Side by Side Comparison',
        path: PRICING_ROUTES.SIDE_COMPARISON_PATH,
        dashboardKey: PRICING_ROUTES.SIDE_COMPARISON_ID,
        element: <PricingSideComparisonPage />
    }]
}